import {Component, h, Prop, Watch , Event, EventEmitter} from "@stencil/core";
import {shopIntegrationState} from "../../../utils/store";

@Component({
  tag: "ike-modal",
  styleUrl: "ike-modal.scss",
  shadow: true,
})
export class IkeModal {
  @Prop({mutable: true, reflect: true}) public visible = true;

  @Event() closeIkeModal : EventEmitter;

  @Watch('visible')
  watchVisibleHandler(newValue) {
    if(newValue == true) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "";
    }
  }

  componentWillLoad() {
    if (this.visible) {
      document.body.style.overflowY = "hidden";
    }
  }

  disconnectedCallback() {
    this.visible = false;
  }

  private closeModal() {
    this.visible = false;
    this.closeIkeModal.emit();
  }

  render() {
    return (
      <div class={{"ike-modal-wrapper": true, "visible": this.visible, "is-profile": shopIntegrationState.isProfile}}>
        <div class="ike-modal-background" onClick={() => this.closeModal()}/>
        <div class="ike-modal">
          <div class="ike-modal-content"><slot/></div>
        </div>
      </div>
    );
  }
}
